import { AccountTypeEnum } from "src/app/core/enums/account-type-enum";
import { AuthContext } from "../../auth-context.model";

export  enum LoginType {
    User = 0,
    Client= 1
}

export class UserContext {
    id?: string;
    userName?: string;
    businessUnitId?: string;   
    email?: string;
    firstName?: string;
    lastName?: string;
    socialId?: string;    
    loginType?: LoginType;
    authContext?: AuthContext;
    accountType?: AccountTypeEnum;
    profilePhotoFileId?: string;
    hasViewedReleaseNotes?: boolean;
}